import { Box, Button } from "@mui/material";
import DataList from "components/DataList";
import GenericModal from "components/GenericModal";
import MDTypography from "components/MDTypography";
import { useAppContextController } from "context/AppContext";
import fetchSingleEvent from "layouts/pages/events/actions/fetchSingleEvent";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { useQuery } from "react-query";
import InterviewTeamMemberRow from "./InterviewTeamMemberRow";

const InterviewTeamMembersModal = ({ open, setOpen, event, applicant, onChangeFeedback }) => {
  const { currentLoggedUser } = useAppContextController();
  const { enqueueSnackbar } = useSnackbar();

  const [selectedUser, setSelectedUser] = useState(null);
  const [currentApplicant, setCurrentApplicant] = useState(applicant);

  useEffect(() => {
    setCurrentApplicant(applicant);
  }, [applicant]);

  const onChangeFeedbackInternal = useCallback(
    ({
      applicant: changeApplicant,
      user: changeUser,
      eventUrl: changeEventUrl,
      rating: changeRating,
      note: changeNote,
      isFinal: changeIsFinal,
    }) => {
      setCurrentApplicant((current) => {
        const existingFeedbackIndex = (current.feedback ?? []).findIndex(
          (fb) => fb.createAgent === (changeUser.id ?? changeUser._id)
        );

        const notes = [...(current.notes ?? [])];
        if (changeNote) notes.push(changeNote);

        if (changeIsFinal) {
          // If it's final decision, only update the notes, if necessary
          if (changeNote) {
            return {
              ...current,
              notes,
            };
          }
        }
        if (existingFeedbackIndex >= 0) {
          return {
            ...current,
            feedback: [
              ...(current.feedback ?? []).map((fb) =>
                fb.createAgent === (changeUser.id ?? changeUser._id)
                  ? {
                      ...fb,
                      rating: changeRating,
                    }
                  : fb
              ),
            ],
            notes,
          };
        }
        return {
          ...current,
          feedback: [
            ...(current.feedback ?? []),
            {
              createAgent: changeUser.id ?? changeUser._id,
              agent: "",
              firstName: "",
              lastName: "",
              eventUrl: applicant?.interview?.eventUrl,
              modifiedDate: new Date().toISOString(),
              rating: changeRating,
            },
          ],
          notes,
        };
      });
      onChangeFeedback?.({
        applicant: changeApplicant,
        user: changeUser,
        eventUrl: changeEventUrl,
        rating: changeRating,
        note: changeNote,
        isFinal: changeIsFinal,
      });
    },
    [applicant, onChangeFeedback]
  );

  const allOptionsEvent = { eventUrl: event?.eventUrl };
  const { data: interview, isLoading: isLoadingInterview } = useQuery(
    ["event", allOptionsEvent],
    () => fetchSingleEvent(allOptionsEvent),
    {
      enabled: !!event,
    }
  );

  const handleOpenNotes = (user) => {
    if (user?._id === selectedUser?._id) setSelectedUser(null);
    else setSelectedUser(user);
  };

  const header = (
    <MDTypography variant="h5" color="dark" sx={{ mt: 2, mb: 1, ml: 2 }}>
      {currentApplicant
        ? `Interview Team Members: ${currentApplicant?.firstName} ${currentApplicant?.lastName}`
        : "Interview Team Members"}
    </MDTypography>
  );

  const modalBody = (
    <Box>
      <DataList
        renderRow={(row, idx) => (
          <InterviewTeamMemberRow
            row={row}
            idx={idx}
            onChangeFeedback={onChangeFeedbackInternal}
            selectedApplicant={currentApplicant}
            onOpenNotes={handleOpenNotes}
            isNotesOpen={row?._id === selectedUser?._id}
            event={event}
          />
        )}
        data={interview?.attendees ?? []}
        greybar
        divider
        scrollY
        tableHeight={250}
        height={300}
        isLoading={isLoadingInterview}
        noPadding
      />
    </Box>
  );

  const buttons = (
    <>
      <Box display="flex" flexDirection="column" sx={{ paddingRight: "1rem" }}>
        <Button
          variant="contained"
          style={{ color: "white" }}
          onClick={(e) => {
            setOpen(false);
          }}
        >
          Close
        </Button>
      </Box>
    </>
  );

  return (
    <>
      <GenericModal
        open={open}
        setOpen={setOpen}
        body={modalBody}
        header={header}
        buttons={buttons}
        sx={(theme) => ({
          width: "90% !important",
          maxWidth: "1100px !important",
          // paddingBottom: "10px",
          [theme.breakpoints.down("md")]: {
            "& .MuiCardContent-root": {
              padding: "0px",
            },
          },
        })}
      />
    </>
  );
};

export default InterviewTeamMembersModal;
